import $http from "../../axios";
import { Notification } from "element-ui";

export async function sendMessages(
    { commit, state },
    data = state.sendMessagesPayload
) {
    await $http
        .post("/api/ws/send-messages", data)
        .then(response => {
            commit("setResponseApi", response.data);
        })
        .catch(error => {
            commit("setResponseApi", error.response.data);
        });
}

export async function getTemplates({ commit }) {
    await $http
        .get("/api/ws/templates")
        .then(response => {
            const data = response.data.data;
            commit("setTemplates", data);
            commit(
                "setDefaultTemplate",
                data.find(item => item.name === "hello_world")
            );
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 2000,
                customClass: "notification-box"
            });
        });
}



// WEBPACK FOOTER //
// ./src/modules/whatsapp-api/actions.js